export default __webpack_public_path__ + "static/media/on-dev.2edb55d4.png";